import { __decorate } from "tslib";
import { Route } from '../core';
var HardwareMobileShop = /*@__PURE__*/ (function () {
    function HardwareMobileShop() {
    }
    HardwareMobileShop.get = function (response) {
        return response;
    };
    HardwareMobileShop = __decorate([
        Route('/vlux/products/hardwaremobile-shop.json')
    ], HardwareMobileShop);
    return HardwareMobileShop;
}());
export { HardwareMobileShop };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/endpoints/hardwaremobile-shop.ts
// module id = null
// module chunks = 